<template>
  <div class="single-question quiz-answers">
    <div v-for="(answer, index) in shuffledAnswers"
         class="quiz-answer" :key="`${index}-${componentKey}`">
      <button class="btn btn-action btn-answer"
              @click="sendAnswer([answer.originalIndex]); $event.target.blur();"
              :class="getButtonClass(index)"
              :disabled="resolve"
              :data-question-number="index + 1">
        <span class="question-num">{{ indexToLetter(index) }}.</span>
        {{ answer.answer.content }}
      </button>

      <blockquote class="quiz-explanation" v-if="resolve">
        <i class="icon icon-message"></i> {{ answer.answer.explanation }}
      </blockquote>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleQuestion',
  props: ['question', 'resolve', 'sendAnswer'],
  computed: {
    shuffledAnswers() {
      const taggedAnswers = this.question.answers.map((answer, index) => ({
        answer,
        originalIndex: index,
      }));

      return this.shuffle(taggedAnswers);
    },
  },
  data() {
    return {
      componentKey: 0,
    };
  },
  beforeUpdate() {
    this.componentKey += 1;
  },
  methods: {
    getButtonClass(index) {
      const cl = [];

      if (this.resolve) {
        cl.push(this.question.resolution.includes(index) ? 'option-correct' : 'option-wrong');
      }

      if (this.question.answer && this.question.answer.includes(index)) {
        cl.push('checked-option');

        if (this.resolve) {
          cl.push(this.question.resolution.includes(index) ? 'checked-option-correct' : 'checked-option-wrong');
        }
      }

      return cl.join(' ');
    },
    shuffle(array) {
      // Loop backward from the last element
      for (let i = array.length - 1; i > 0; i -= 1) {
        // Pick a random index from 0 to i
        const j = Math.floor(Math.random() * (i + 1));

        // Swap the elements at positions i and j
        [array[i], array[j]] = [array[j], array[i]];
      }

      return array;
    },
  },
};
</script>
